import { Box } from "@mui/material";
import { PropsWithChildren } from "react";

export interface Props extends PropsWithChildren {
  borderRadius?: string;
}

export const RotatingBorder: React.FC<Props> = ({ children, borderRadius }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        position: "relative",
        borderRadius: borderRadius || "16px",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: "-20%",
          background: `conic-gradient(#5e35b1)`,
          animation: "spin 3s linear infinite",
        },
        "&::after": {
          content: '""',
          position: "absolute",
          inset: "2px",
          backgroundColor: "white",
          borderRadius: borderRadius || "16px",
        },
        "@keyframes spin": {
          "0%": { transform: "rotate(0deg)" },
          "100%": { transform: "rotate(360deg)" },
        },
      }}
    >
      <Box sx={{ zIndex: 1 }}>{children}</Box>
    </Box>
  );
};
